<template>
  <a ref="linkEl" :href="downloadUrl" class="button is-atus-yellow is-small" :tabindex="0" @mouseenter="showTooltip"
     @mouseleave="hideTooltip" @focus="showTooltip" @blur="hideTooltip">
    Download All Linking Counts
  </a>
</template>

<script setup>
import { computed, ref, inject } from "vue";
import { getBaseUrl, makeTooltipData } from "../lib/helpers";

const tooltip_data = inject("tooltip_data");
const linkEl = ref(null);

const downloadUrl = computed(() => {
  return `${getBaseUrl()}/api/atus_linking_counts/csv`;
});

function showTooltip() {
  const rect = linkEl.value.getBoundingClientRect();
  const containerHeight = window.innerHeight;

  tooltip_data.value = makeTooltipData({
    show_tooltip: true,
    bottom: containerHeight - rect.bottom,
    left: rect.left - 290 - 10, // left of button

    // Button tooltip content
    text: "Linking count CSVs contain the number of expected/maximum linkages " +
        "between the ATUS and CPS for each ATUS-CPS linking option."
  });
}

function hideTooltip() {
  tooltip_data.value = makeTooltipData({show_tooltip: false});
}

</script>
